import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash"
export default class extends Controller {
  static targets = ["toast", "progressBar"];

  connect() {
    const duration = 4000; // Toast lifespan in milliseconds

    // 1. Animate In (Slide down and scale in)
    requestAnimationFrame(() => {
      this.toastTarget.classList.remove(
        "-translate-y-4",
        "opacity-0",
        "scale-95",
      );
    });

    // 2. Animate the progress bar shrinking to 0
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.transition = `transform ${duration}ms linear`;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.progressBarTarget.style.transform = "scaleX(0)";
        });
      });
    }

    // 3. Auto-dismiss when the time is up
    this.timeout = setTimeout(() => {
      this.dismiss();
    }, duration);
  }

  dismiss() {
    clearTimeout(this.timeout);

    // Slide back up and fade out
    this.toastTarget.classList.add("-translate-y-4", "opacity-0", "scale-95");

    // Remove from the DOM after the CSS transition completes
    setTimeout(() => {
      this.element.remove();
    }, 500);
  }
}
